<div class="flex flex-col h-full w-full overflow-hidden">
  <!-- Header -->
  <div class="flex justify-between items-center p-4 h-auto">
    <!-- Logo -->
    <div class="w-30 h-auto">
        <img class="w-90 h-auto" src="images/logo/logo.svg" />
    </div>

    <!-- Close button -->
    <button mat-icon-button mat-dialog-close (click)="closeDialog()" class="icon-size-2" *ngIf="shouldShowCloseButton()">
        <mat-icon>close</mat-icon>
    </button>
    
  </div>

  <!-- Main Content - Enhanced for better space distribution -->
  <div class="flex-grow flex flex-col h-full px-4 sm:px-6">
    <!-- Top section with title and text -->
    <div class="flex flex-col items-center justify-center w-full pt-10 sm:pt-14 mb-2 sm:mb-6">
      <h1 class="text-3xl sm:text-3xl font-extrabold leading-tight text-center">
        {{ 'unauthorized.blockedwebtext' | transloco }}
      </h1>
      
    </div>
    
  </div>
</div>